var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWatched(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#watched_svg__clip0_3830_2178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.184 12.2c-.028-.075-.825-1.837-2.587-3.61C18.244 6.248 15.272 5 12 5 8.728 5 5.756 6.247 3.403 8.59 1.641 10.364.843 12.126.816 12.2a.74.74 0 000 .6c.028.075.825 1.837 2.587 3.61C5.756 18.752 8.728 20 12 20c3.272 0 6.244-1.247 8.597-3.59 1.762-1.773 2.56-3.535 2.587-3.61a.74.74 0 000-.6zM12 9.125a3.375 3.375 0 110 6.75 3.375 3.375 0 010-6.75z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "watched_svg__clip0_3830_2178"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .5)",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgWatched;